// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__tHYJl","paper":"style_paper__E4R0e","input":"style_input__eLNSd","logo":"style_logo__T3JhV"};